import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconStar = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M9.81267 1.50099C9.87746 1.32772 10.1225 1.32772 10.1873 1.50099L12.4223 7.47815C12.4504 7.55332 12.5208 7.6044 12.6009 7.60791L18.9762 7.88648C19.161 7.89456 19.2368 8.12765 19.092 8.24281L14.098 12.2155C14.0352 12.2654 14.0084 12.3481 14.0298 12.4254L15.7349 18.5748C15.7844 18.753 15.5861 18.8971 15.4318 18.795L10.1104 15.2731C10.0435 15.2288 9.95654 15.2288 9.88962 15.2731L4.56818 18.795C4.41392 18.8971 4.21564 18.753 4.26507 18.5748L5.97019 12.4254C5.99164 12.3481 5.96478 12.2654 5.90197 12.2155L0.908015 8.24281C0.763247 8.12765 0.838983 7.89456 1.02379 7.88648L7.39906 7.60791C7.47924 7.6044 7.54955 7.55332 7.57766 7.47815L9.81267 1.50099Z" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  )
}

export default IconStar
